exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(//at.alicdn.com/t/font_522428_qwl4oi0r2p6cg14i.css);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/style/font.less
// module id = ../../../../../src/app/style/font.less
// module chunks = main